import styled from '@emotion/styled'
import background from '../../../background.jpg'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  background: white;
  border-radius: 4px;
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden;
`

export const MessagesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex-grow: 1;
  background-image: url(${background});
  background-size: cover;
  background-position: center;
  padding: 5px;
  min-width: 100px;
  overflow: hidden;
`

export const Chats = styled.div`
  display: flex;
  flex-direction: column;
 justify-content: flex-end;
  gap: 10px;
  flex-grow: 1;
  min-width: 100px;
  overflow: auto;
`

export const RecievedMessage = styled.span`
  background: #f2f2f2;
  border-radius: 4px;
  padding: ${props => props.voiceType ? '0' : '5px 10px 15px 10px'};
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
`
export const SentMessage = styled.span`
  background: #f2f2f2;
  border-radius: 4px;
  align-self: flex-start;
  padding: ${props => props.voiceType ? '0' : '5px 10px 15px 10px'};
  position: relative;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
`

export const Row = styled.span`
  direction: ltr;
  display: flex;
  gap: 5px;
  align-self: flex-end;
  justify-content: start;
  align-items: center;
`

export const VoiceContainer = styled.div`
  position: relative;
  width: 78%;
`

export const WritingMessageBox = styled.div`
  display: flex;
  align-items: center;
  padding-left: 10px;
  border: 1px solid #b8b8b8;
  border-radius: 4px;
  div {
    flex-grow: 1;
  }
`
export const Timer = styled.span`
  display: inline-flex;
  width: 45px;
  direction: ltr;
`

export const HelpNote = styled.div`
  background: #fff;
  border-radius: 4px;
  width: 90%;
  padding: 5px 10px;
  direction: rtl;
  align-self: center;
`

export const MessageTime = styled.span`
  color: #6fa1e5;
  font-size: 11px;
  direction: ltr;
  min-width: 82px;
  bottom: 0;
  &.sent {
   padding-inline-end: 10px;
  }
  &.recieved {
   padding-inline-start: 10px;
  }
`

export const Status = styled.span`
  background: #f9fafc;
  border: 2px solid #d9e2ed;
  border-radius: 10px;
  padding-inline: 5px;
  padding-bottom: 1px;
  display: flex;
  font-size: 13px;
  color: #1C2025;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  .MuiSelect-outlined {
    padding-block: 8px;
  }
`

export const AdminFiltersWrapper = styled.div`
  direction: rtl;
  display: flex;
  gap: 5px;
  justify-content: space-between;
  align-items: center;
`

export const Image = styled.img`
  margin: 5px;
  cursor: pointer;
 `

export const FullImage = styled.img`
  margin: 5px;
  display: flex;
  width: 100%;
  height: 100%;
  object-fit: contain;
  align-items: center;
  justify-content: center;
 `

export const Speed = styled.span`
  border-radius: 50%;
  background-color: #cdcdcd;
  width: 22px;
  height: 22px;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  left: 20px;
  font-size: 12px;
`

export const SpeedContainer = styled.div`
  display: flex;
  flex-direction: column;
`
